"use strict";
var trimmedEndIndex = require('./_trimmedEndIndex');
var reTrimStart = /^\s+/;
function baseTrim(string) {
    return string
        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
        : string;
}
module.exports = baseTrim;
//# sourceMappingURL=_baseTrim.js.map